(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('grcTestResultNavController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {
        $scope.controlTestResults = $scope.boxModel;

        // Get Number Of Test Results
        $scope.getNumberOfTestResults = function () {
            if (!$scope.controlTestResults) return;

            var previousResultsNb = $scope.controlTestResults.PreviousTestResults ? $scope.controlTestResults.PreviousTestResults.length : 0;

            if ($scope.controlTestResults.ActualTestResult && $scope.controlTestResults.ActualTestResult.TestResultID) {
                return previousResultsNb + 1;
            }

            return previousResultsNb;
        };
    }
})();